import {
  getAccountByCNPJ,
  getContactByEmail,
  createLead,
} from './xanoSalesforce';

type RegisterPayload = {
  isCompany: boolean;
  cnpj?: string; // obrigatório se isCompany = true
  email: string;
  firstName?: string;
  lastName: string; // Salesforce exige LastName
  phone?: string;
  mobile?: string;
};

type SalesforceIds = {
  id_sf_account?: string | null;
  id_sf_contact?: string | null;
  id_sf_lead?: string | null;
};

// Função que você chama durante o submit do cadastro
export async function resolveSalesforceIds(
  p: RegisterPayload
): Promise<SalesforceIds> {
  if (p.isCompany) {
    if (!p.cnpj) throw new Error('CNPJ obrigatório para empresa.');

    // 1) tenta achar Account pelo CNPJ
    try {
      const accountId = await getAccountByCNPJ(p.cnpj);
      if (accountId) {
        return {
          id_sf_account: accountId,
          id_sf_contact: null,
          id_sf_lead: null,
        };
      }
    } catch (error) {
      // Continua para criar Lead mesmo se houver erro
    }

    // 2) não achou → cria Lead com CNPJ
    try {
      const leadId = await createLead({
        FirstName: p.firstName,
        LastName: p.lastName,
        Email: p.email,
        Phone: p.phone,
        MobilePhone: p.mobile,
        CNPJ: p.cnpj,
      });

      return {
        id_sf_account: null,
        id_sf_contact: null,
        id_sf_lead: leadId ?? null,
      };
    } catch (error) {
      // Em caso de erro, retorna IDs vazios para não bloquear o registro
      return { id_sf_account: null, id_sf_contact: null, id_sf_lead: null };
    }
  } else {
    // PF
    try {
      const contactId = await getContactByEmail(p.email);
      if (contactId) {
        return {
          id_sf_account: null,
          id_sf_contact: contactId,
          id_sf_lead: null,
        };
      }
    } catch (error) {
      // Continua para criar Lead mesmo se houver erro
    }

    try {
      const leadId = await createLead({
        FirstName: p.firstName,
        LastName: p.lastName,
        Email: p.email,
        Phone: p.phone,
        MobilePhone: p.mobile,
      });

      return {
        id_sf_account: null,
        id_sf_contact: null,
        id_sf_lead: leadId ?? null,
      };
    } catch (error) {
      // Em caso de erro, retorna IDs vazios para não bloquear o registro
      return { id_sf_account: null, id_sf_contact: null, id_sf_lead: null };
    }
  }
}
